import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

type PendingEvaluationTimeframe = 'upcoming' | 'past'

type PendingEvaluation = {
  workerId: number
  workerName: string
  companyId: number
  companyName: string
  positionId: number
  positionName: string
  shiftId: number
  shiftStartsAt: string
  lastCallEndedAt: string
}

type ListPendingEvaluationsParams = {
  timeframe: PendingEvaluationTimeframe
  companyId?: number
  positionId?: number
  shiftId?: number
  cursor?: string
  pageSize?: number
}

type ListPendingEvaluationsResponse = {
  assessments: PendingEvaluation[]
  nextCursor: string | null
}

export const listPendingEvaluations = async (
  params: ListPendingEvaluationsParams
): Promise<ListPendingEvaluationsResponse> => {
  const result = await api.get<ListPendingEvaluationsResponse>(
    '/admin/positions/assessments/pending_evaluations',
    {
      params,
      paramsSerializer: queryParamSerializer,
    }
  )
  return result.data
}
